import type {Icon} from '@primer/octicons-react'

import {CustomIcon} from './CustomIcon'

export const MacOSIcon: Icon = props => {
  return (
    <CustomIcon {...props}>
      <path d="M12.8322 15.3601C11.965 16.2017 11.0082 16.0705 10.0962 15.6737C9.12656 15.2689 8.24016 15.2433 7.21616 15.6737C5.94096 16.2241 5.26416 16.0641 4.49616 15.3601C0.160159 10.8961 0.800159 4.09611 5.72816 3.84011C6.92336 3.90411 7.76016 4.5009 8.46416 4.5505C9.51056 4.3377 10.5122 3.72811 11.6322 3.80811C12.9778 3.91691 13.9842 4.4481 14.6562 5.4033C11.8882 7.0673 12.5442 10.7153 15.0866 11.7393C14.5778 13.0753 13.925 14.3953 12.8306 15.3713L12.8322 15.3601ZM8.36816 3.79211C8.23856 1.80811 9.84656 0.176113 11.6962 0.0161133C11.9506 2.30411 9.61616 4.01611 8.36816 3.79211Z" />
    </CustomIcon>
  )
}
